/**
 * Barra do topo, comum ao painel de status e às páginas legais.
 *
 * A imagem vem de `/marca`, que sai de `frontend/public/marca` — copiado tal e
 * qual pelo Vite, sem passar pelo empacotador. É a mesma pasta que os diagramas
 * em `frontend/diagrams/` alcançam por caminho relativo, e por isso ela não pode
 * ganhar hash no nome: uma cópia só, uma fonte da verdade.
 */
export function Header({ badge }) {
  return (
    <header className="bar">
      <img className="mark" src="/marca/iguatemi_logotipo_white.png" alt="Iguatemi" />
      <div>
        <span className="nm">AI Hub</span>
        <small>Iguatemi · Inovação e IA</small>
      </div>
      {badge && <span className="phase">{badge}</span>}
    </header>
  );
}
